"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.is-array.js");

var _resizeEvent = require("element-ui/lib/utils/resize-event");

var _scrollbarWidth = _interopRequireDefault(require("element-ui/lib/utils/scrollbar-width"));

var _util = require("element-ui/lib/utils/util");

var _bar = _interopRequireDefault(require("./bar"));

// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js

/* istanbul ignore next */
var _default = {
  name: 'ElScrollbar',
  components: {
    Bar: _bar["default"]
  },
  props: {
    "native": Boolean,
    wrapStyle: {},
    wrapClass: {},
    viewClass: {},
    viewStyle: {},
    noresize: Boolean,
    // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
    tag: {
      type: String,
      "default": 'div'
    }
  },
  data: function data() {
    return {
      sizeWidth: '0',
      sizeHeight: '0',
      moveX: 0,
      moveY: 0
    };
  },
  computed: {
    wrap: function wrap() {
      return this.$refs.wrap;
    }
  },
  render: function render(h) {
    var _vm = this;

    var gutter = (0, _scrollbarWidth["default"])();
    var style = this.wrapStyle;

    if (gutter) {
      var gutterWith = "-".concat(gutter, "px"); // 扩展

      var rightGutter = gutter;

      if (gutter < 17) {
        rightGutter += 2;
      }

      var rightGutterWidth = "-".concat(rightGutter, "px");
      var gutterStyle = "margin-bottom: ".concat(gutterWith, "; margin-right: ").concat(rightGutterWidth, ";");

      if (Array.isArray(this.wrapStyle)) {
        style = (0, _util.toObject)(this.wrapStyle);
        style.marginBottom = gutterWith;
        style.marginRight = rightGutterWidth;
      } else if (typeof this.wrapStyle === 'string') {
        style += gutterStyle;
      } else {
        style = gutterStyle;
      }
    }

    var view = h(this.tag, {
      "class": ['el-scrollbar__view', this.viewClass],
      style: this.viewStyle,
      ref: 'resize'
    }, this.$slots["default"]);
    var wrap = h("div", (0, _babelHelperVueJsxMergeProps["default"])([{
      "ref": "wrap",
      "on": {
        "scroll": this.handleScroll
      },
      "class": [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default']
    }, {
      style: _vm._px2rem(style, 24, ['height', 'marginRight', 'marginBottom'])
    }]), [[view]]);
    var nodes;

    if (!this["native"]) {
      nodes = [wrap, h(_bar["default"], {
        "attrs": {
          "move": this.moveX,
          "size": this.sizeWidth
        }
      }), h(_bar["default"], {
        "attrs": {
          "vertical": true,
          "move": this.moveY,
          "size": this.sizeHeight
        }
      })];
    } else {
      nodes = [h("div", (0, _babelHelperVueJsxMergeProps["default"])([{
        "ref": "wrap",
        "class": [this.wrapClass, 'el-scrollbar__wrap']
      }, {
        style: _vm._px2rem(style, 24, [])
      }]), [[view]])];
    }

    return h('div', {
      "class": 'el-scrollbar'
    }, nodes);
  },
  methods: {
    handleScroll: function handleScroll(event) {
      var wrap = this.wrap;
      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
      this.$emit('scroll', event);
    },
    update: function update() {
      var heightPercentage, widthPercentage;
      var wrap = this.wrap;
      if (!wrap) return;
      heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
      widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;
      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
    },
    // 扩展 滚动到最上方
    scrollToTop: function scrollToTop() {
      // 设为0时，不会触发更新bar的位置，所以设为0.01
      this.wrap.scrollTop = 0.01;
    },
    // 扩展 滚动到最下方
    scrollToBottom: function scrollToBottom() {
      this.wrap.scrollTop = this.wrap.scrollHeight;
    }
  },
  mounted: function mounted() {
    if (this["native"]) return;
    this.$nextTick(this.update); // 扩展

    !this.noresize && (0, _resizeEvent.addResizeListener)(this.$refs.resize, this.update);
    !this.noresize && (0, _resizeEvent.addResizeListener)(this.$el, this.update);
  },
  beforeDestroy: function beforeDestroy() {
    if (this["native"]) return; // 扩展

    !this.noresize && (0, _resizeEvent.removeResizeListener)(this.$refs.resize, this.update);
    !this.noresize && (0, _resizeEvent.removeResizeListener)(this.$el, this.update);
  }
};
exports["default"] = _default;